import { render, staticRenderFns } from "./admitCardCountByPaper.vue?vue&type=template&id=5e842ce5&scoped=true&"
import script from "./admitCardCountByPaper.vue?vue&type=script&lang=js&"
export * from "./admitCardCountByPaper.vue?vue&type=script&lang=js&"
import style0 from "./admitCardCountByPaper.vue?vue&type=style&index=0&id=5e842ce5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e842ce5",
  null
  
)

export default component.exports